import { Link, useNavigate } from 'react-router-dom'
import { fullDate } from '../../Reusables/fullDate'
import { getAuth, signOut } from "firebase/auth";
import useUser  from "../../useUser";

export default function NavBar() {

    const navigate = useNavigate();
    const { user } = useUser();
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return(
        <>
        <nav>
            <ul>
                <li><Link to="/">All Sports</Link></li>
                <li><Link to={`/nfl/${fullDate()}?tz=${encodeURIComponent(userTimezone)}`}>NFL</Link></li>
                <li><Link to={`/nba/${fullDate()}?tz=${encodeURIComponent(userTimezone)}`}>NBA</Link></li>
                <li><Link to={`/mlb/${fullDate()}?tz=${encodeURIComponent(userTimezone)}`}>MLB</Link></li>
                <li><Link to={`/epl/${fullDate()}?tz=${encodeURIComponent(userTimezone)}`}>EPL</Link></li>
                <li><Link to={`/wc2026/${fullDate()}?tz=${encodeURIComponent(userTimezone)}`}>WC2026</Link></li>
            </ul>
        </nav>
        <div className='loginButton'>
            {user && (<li>Logged-in as: {user.email}</li>)}
            {user
                ? <button onClick={()=>{signOut(getAuth())}}>Sign Out</button>
                : <button onClick={()=>{navigate("/loginPage")}}>Sign In</button>

            }
        </div>
        </>
    )
}
